import { Box, Typography } from "@mui/material";
import CountUp from "react-countup";
import type { CounterBoxProps } from "./types/CounterBoxProps";
import { useInView } from "react-intersection-observer";
import { theme } from "@/theme";

export function CounterBox({ end, duration = 4, prefix, suffix, label, description }: CounterBoxProps) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const displaySuffix = suffix ? ` ${suffix}` : "";

  return (
    <Box sx={{ maxWidth: 330 }}>
      <Box ref={ref} sx={{ textAlign: "center" }}>
        <Typography sx={{ fontSize: 46, fontWeight: "bold", marginBottom: "-15px", color: theme.palette.primary.main }}>
          {inView ? (
            <CountUp end={end} duration={duration} prefix={prefix} suffix={displaySuffix} />
          ) : (
            `${prefix ?? ""}0${displaySuffix}`
          )}
        </Typography>
        <Typography sx={{ textTransform: "uppercase", fontWeight: "bold" }}>{label}</Typography>
        <Typography sx={{ textTransform: "uppercase", fontSize: 14 }}>{description}</Typography>
      </Box>
    </Box>
  );
}
